import  { useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Tooltip, IconButton, FormControl, FormControlLabel,
    Grid, LinearProgress, 
    Button,
    Card,
    CardContent,
    Typography} from '@material-ui/core'
import axios from 'axios';
import moment from "moment";
import qs from 'qs';
import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../../funciones/ClienteAxios';
import Relojes from "./Relojes";
import ReplayIcon from '@material-ui/icons/Replay';
import GraficaDirect from "./Grafica";
import TablaCombustible from "./TablaCombustible";
const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },

}));


const Combustible = ({regisMaquinaria}) => {
    let history = useHistory();
    const classes = useStyles();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const [listTipo, setListTipo] = useState([])
    const [listObra, setListObra] = useState([])
    const [fSeleccionadas, setFSeleccionadas] = useState({inicio:new Date(),final:new Date()});    
    
    const [espera, setEspera] = useState(false);
    const [buscar, setBuscar] = useState(false);
    const [opcion, setOpcion] = useState(1);
    const [listCombustible, setListCombustible] = useState([]);
    const [listCombOriginal, setListCombOriginal] = useState([]);
    const [filtro, setFiltro] = useState({IsFecha:1, Tipo:0, Encendido:0, Obra:0, Cadena:""});
    const { IsFecha, Tipo, Encendido, Obra, Cadena}=filtro
    useEffect(() => {                       
        //getListCombustible()
        //getListTipo()
        //getListObra()
        return () => {
            source.cancel();
        }
    }, []);

    useEffect(()=>{
        getListCombustible()
    },[buscar])

    const getListCombustible= () => {
        const fInicio=moment(fSeleccionadas.inicio).format("YYYY-MM-DD")
        const fFinal=moment(fSeleccionadas.final).format("YYYY-MM-DD")
        const data = qs.stringify({
            Usuario:idusu,                      
            IsFecha:IsFecha,
            Maquinaria:regisMaquinaria.Id,
            FIni:`${fInicio}T00:00:00`,
            FFin:`${fFinal}T23:59:59`,
            Tipo:Tipo,
            Status:0,
            Encendido:Encendido,
            Obra:Obra,
            Cadena:Cadena,
            idDispositivo: '987gyubjhkkjh',
            ip:"172.0.0.0",
        });
        const url = "/maquinaria/v1/combustible/dashboard";
    
        function respuesta(aux) {
            if (aux[0].Id!==-1) 
            {                  
                let nvoArr=[]           
                if (aux.length>1) 
                {   aux.forEach(element => {
                        nvoArr.push({...element})
                         
                    });                    
                }
                else
                {   if (aux[0].Maq===0) 
                    {   nvoArr=[]    
                    }
                    else
                    {   //aux[0] 
                        nvoArr= aux
                                                            
                    }                
                } 
                setOpcion(1)  
                setListCombustible(nvoArr)
                setListCombOriginal(aux)         
            }         
        }
        llamadaApiToken(data, url,respuesta,ErrorGeneral, history,source);
    };  

    const getListTipo= () => {
 
        const data = qs.stringify({
            Usuario:idusu,    
            idDispositivo: '987gyubjhkkjh',
            ip:"172.0.0.0",
        });
        const url = "/maquinaria/tipo";
    
        function respuesta(aux) {
          if (aux[0].Id!==-1) 
          {                  
            setListTipo(aux);                                      
          }         
        }
        llamadaApiToken(data, url,respuesta,ErrorGeneral, history,source);
    };  

    const getListObra= () => {
 
        const data = qs.stringify({
            Usuario:idusu,    
            idDispositivo: '987gyubjhkkjh',
            ip:"172.0.0.0",
        });
        const url = "/maquinaria/ubicacion";
    
        function respuesta(aux) {
          if (aux[0].Id!==-1) 
          {                  
            setListObra(aux);                                      
          }         
        }
        llamadaApiToken(data, url,respuesta,ErrorGeneral, history,source);
    };  

    const reOrdenar=(tipo)=>{
        let nvoArr=[]           
        if (listCombOriginal.length>1 && tipo===2) 
        {   listCombOriginal.forEach(element => {
                element.det.forEach((registro)=>{
                    nvoArr.push({...registro, Mes:element.Mes})
                })
            });            
        }
        else
        {   if (listCombOriginal[0].Maq===0) 
            {   nvoArr=[]
            }
            else
            {   if (tipo===2) 
                {   listCombOriginal[0].det.forEach((registro)=>{
                        nvoArr.push({...registro, Mes:listCombOriginal[0].Mes})
                    })                
                }
                else
                {   nvoArr= listCombOriginal
                }                                                                       
            }                
        }             
        
        setListCombustible(nvoArr)
        setOpcion(tipo)
    }

    const principal = () => {        
        const auxCol =process.env.REACT_APP_COLOR
        const estiloMes= opcion ===1 ? {backgroundColor: auxCol, color: "white"}:{backgroundColor:"", color: auxCol}
        const estiloTodos= opcion ===2 ? {backgroundColor: auxCol, color: "white"}:{backgroundColor:"", color: auxCol}
        return (
        <>
 
        <Box  display={"flex"} flexDirection={"column"} alignItems={'flex-start'} >
            <Box display={"flex"} flexDirection={"row"}>
            <Relojes fechasSeleccionadas={fSeleccionadas} 
                setFechasSeleccionadas={setFSeleccionadas} />
            <Tooltip title="Actualizar">
                <IconButton color="primary" size={"small"} onClick={()=>setBuscar(!buscar)}
                    style={{paddingTop: '.6rem'}}>
                    <ReplayIcon/>
                </IconButton>
            </Tooltip>
                {listCombOriginal.length!==0 && listCombOriginal[0].CantAvg !==0?
                <Box mt={2}>
                <Card style={{ ...estiloMes,padding:0, margin:0, minWidth:"6rem", marginLeft:"1rem", textAlign:"center"}} 
                    onClick={()=>{reOrdenar(1)}}>
                    <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem",  fontWeight:600}} > Meses</CardContent>
                </Card>  
                </Box>
                :null}
                {listCombOriginal.length!==0 && listCombOriginal[0].CantAvg !==0?
                <Box mt={2}>
                    <Card style={{ ...estiloTodos,padding:0, margin:0, minWidth:"6rem", marginLeft:"1rem", textAlign:"center"}} 
                        onClick={()=>{reOrdenar(2)}}>
                        <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem",  fontWeight:600}} > Dias</CardContent>
                    </Card>  
                </Box>
                :null}
               
            </Box>
            {listCombustible.length!==0 ?
                <GraficaDirect lista={listCombustible} leyenda={"Combustible"} opcion={opcion} />
                : listCombOriginal.length===0 || listCombOriginal[0].CantAvg ===0? <Typography style={{marginLeft:"1rem", color:auxCol}}> Rango de fechas sin registros</Typography>:null }
                
           {/*  <Box width={"40rem"}  >
                {espera ? 
                    (<Box mt={5} ml={2}><LinearProgress/> </Box>) 
                :   <TablaOrden 
                  
                        registro={regisMaquinaria} 
                     
                    />
                }
            </Box > */}
            <TablaCombustible regisMaquinaria={regisMaquinaria}  fSeleccionadas={fSeleccionadas} buscar={buscar} />
        </Box >
        </>
        )
    }

 
    return (
    <>
        {principal()}
        
    </>
    )
}

export default Combustible